import { gql } from '@apollo/client';
import { useMutation } from 'platform/useMutation';
import {
  RemoveFavoriteProperty,
  RemoveFavoritePropertyVariables,
} from 'buying/graphql/__generated__/RemoveFavoriteProperty';
import { evictGetFavoritePropertiesForCurrentUserFromCache } from 'buying/graphql/useProperties';

const REMOVE_FAVORITE_PROPERTY = gql`
  mutation RemoveFavoriteProperty(
    $input: OdProtosBuyerServicesBuyer_PropertyRequests_RemoveFavoritePropertyInput!
  ) {
    buyer {
      removeFavoriteProperty(input: $input) {
        property {
          id
          isFavorite
        }
      }
    }
  }
`;

/** Remove Favorite Property hook */
export const useRemoveFavoriteProperty = () =>
  useMutation<RemoveFavoriteProperty, RemoveFavoritePropertyVariables>(REMOVE_FAVORITE_PROPERTY, {
    refetchQueries: ['BuyerCurrentUser', 'GetFavoritePropertiesForCurrentUser'],
    update: evictGetFavoritePropertiesForCurrentUserFromCache,
  });
